import React from 'react'

export const ArrowUp = () => {
  return (
    <svg
      width="13"
      height="9"
      viewBox="0 0 13 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.745605 7.95228L6.49986 2.19775L12.2544 7.95228"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  )
}
